import { render, staticRenderFns } from "./SecurityGuardAdd.vue?vue&type=template&id=ead367f8&scoped=true&"
import script from "./SecurityGuardAdd.vue?vue&type=script&lang=js&"
export * from "./SecurityGuardAdd.vue?vue&type=script&lang=js&"
import style0 from "./SecurityGuardAdd.vue?vue&type=style&index=0&id=ead367f8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead367f8",
  null
  
)

export default component.exports